import React from 'react'

import './column_link.css'

const ColumnLink = (({url,title,description})=>(
	<a href={url} className="column__link">
		<div className="title">{title}</div>
		<span>{description}</span>
		<i className="fa fa-chevron-right"></i>
	</a>
))

export default ColumnLink


// WEBPACK FOOTER //
// ./src/Components/ColumnLinks/ColumnLink/index.js